import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { container } from "setup/dependency/inversify.config";
import { IUsersService } from "services/UsersService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { NewUserModel } from "services/api/cplauthapi/CPLAuthAPI";
import { toast } from "react-toastify";
import { RootState } from "setup";

const initialState = {
  IsBusy: false,
  IsCreated: false,
};

export const newUserProfileSlice = createSlice({
  name: "newUser",
  initialState,
  reducers: {
    setIsBusy: (state, action) => {
      state.IsBusy = action.payload;
    },
    resetState: (state) => {
      state.IsBusy = false;
      state.IsCreated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createNewUser.pending, (state) => {
        state.IsBusy = true;
        state.IsCreated = false;
      })
      .addCase(createNewUser.rejected, (state) => {
        state.IsBusy = false;
      })
      .addCase(createNewUser.fulfilled, (state, action) => {
        const { createCoreUser } = action.payload;
        if (createCoreUser) {
          toast.success(
            "Connect and Core user accounts have been successfully created. Please assign appropriate permissions to the user in Core."
          );
        } else {
          toast.success("User created");
        }
        state.IsBusy = false;
        state.IsCreated = true;
      });
  },
});

export const createNewUser = createAsyncThunk("newUser/createNewUser", async ({ user }: { user: NewUserModel }) => {
  const usersService = container.get<IUsersService>(SERVICE_TYPES.UsersService);
  if (user.createCoreUser) {
    user.rpmUserId = await usersService.createCoreUser(user);
  }
  const newUserCreateResponse = await usersService.createNewUser(user);
  return { newUserCreateResponse, createCoreUser: user.createCoreUser };
});

export const selectNewUserProfile = () => {
  const userDetails = new NewUserModel();
  userDetails.firstName = "";
  userDetails.lastName = "";
  userDetails.telephoneNumber = "";
  userDetails.emailAddress = "";
  userDetails.createCoreUser = false;
  return userDetails;
};

export const { resetState } = newUserProfileSlice.actions;

export const selectIsBusy = (state: RootState) => {
  return state.newUserProfile.IsBusy;
};
export const selectIsCreated = (state: RootState) => {
  return state.newUserProfile.IsCreated;
};
export default newUserProfileSlice.reducer;
